import React from 'react'
import { ForEachModel } from '@morningtrain/react-resources'
import ListDay from 'widgets/shifts/themes/list/ListDay'

export default function List ({ mode = 'view' }) {
  return (
    <div className='group space-y-12 pt-8 border-t border-gray-200'>
      <ForEachModel>
        <ListDay mode={mode} />
      </ForEachModel>
    </div>
  )
}
